import MainLayout from '@layouts/main';
import { useSession } from 'next-auth/react';
import { useRouter } from 'next/router';
import type { PropsWithChildren } from 'react';
import { Roles } from '@lib/domain/auth';
import { EuiEmptyPrompt, EuiPageTemplate } from '@elastic/eui';
import { MdSecurity } from 'react-icons/md';

const RouteGuard = (props: PropsWithChildren) => {
  const { children } = props;
  const router = useRouter();
  const { data: session, status } = useSession();

  const authenticated = status === 'authenticated';

  let authorized = false;

  if (
    router.pathname.startsWith('/auth') ||
    router.pathname.startsWith('/support') ||
    router.pathname.startsWith('/error')
  ) {
    authorized = true;
  }

  if (session?.user.roles.includes(Roles.AuthAdmin)) {
    authorized = true;
  }

  if (authorized) {
    return children;
  } else if (!authenticated) {
    return <MainLayout panelled={false} showSpinner={true} />;
  } else {
    return (
      <MainLayout panelled={false}>
        <EuiPageTemplate.EmptyPrompt>
          <EuiEmptyPrompt
            // actions={actions}
            body={
              <p>
                You don&apos;t have permission to access this page. Please
                contact support for assistance.
              </p>
            }
            iconType={MdSecurity}
            layout="vertical"
            title={<h2>Access Denied</h2>}
            titleSize="m"
          />
        </EuiPageTemplate.EmptyPrompt>
      </MainLayout>
    );
  }
};

export default RouteGuard;
